module.exports = function(app) {
	"use strict";
	app.controller('pages.assistEmployees.benefitBooklets', ["$state", "$scope", "sessionData", "services", "$window",
		function ($state, $scope, sessionData, services, $window) {

			$scope.sidebar = { breadCrumb: {} };
			var crumbs = {
				assistEmployees: {
					title: 'Assist Employees',
					state: 'assistEmployees'
				},
				benefitBooklets: {
					title: 'Benefit Booklets',
					state: 'assistEmployees.benefitBooklets'
				}
			};

			var breadCrumb = $scope.sidebar.breadCrumb = {};


            $scope.showWarning = sessionData.employerInfo.brandName==='6012'?false:true;
            $scope.showHeader = sessionData.employerInfo.brandName==='6010'?false:true;

			if ($state.previous.name === 'assistEmployees') {
				breadCrumb.primary = crumbs.assistEmployees;
				breadCrumb.secondary = crumbs.benefitBooklets;
			}
			else {
				breadCrumb.primary = crumbs.benefitBooklets;
			}

			$scope.objFiltering = {
				orderBy: 'planName',
				reverse: false,
				titles: [
					{
						name: "Name",
						dataKey: "planName"
					}
				],
				arrItems: []
			}
            $scope.groupContractArray={

                order:'masterGroupContracts',
                reverse:true,
                titles: [
                    {
                        name: 'Plan Name / Group Number',
                        dataKey: 'masterGroupContracts'
                    },
                    {
                        name: 'Inserts/Addendum(s)',
                        dataKey: 'riders'
                    }
                ],
                arrItems : []

            };

            if(sessionData.employerInfo.brandName == '6010'||sessionData.employerInfo.brandName == '3002' || sessionData.employerInfo.brandName == '3003'|| sessionData.employerInfo.brandName == '6008'||sessionData.employerInfo.brandName == '6009'
                ||sessionData.employerInfo.brandName == '6011'||sessionData.employerInfo.brandName == '6012'){
                $scope.groupContractArray.titles[0].name = 'Plan Name / Group Number';
                $scope.groupContractArray.titles.splice(1,1);
            }

            $scope.feedback = {};

			// ================================================================================================
			// =========== NOTE: the controller logic is in directives/ filterBoxAndTableDisplay ==============
			// ================================================================================================
		}
	]);
};

